export class HttpError extends Error {}

class RequestError extends HttpError {
    public rawMessage: string;
    public status? : number
    static isRequestError(status: number): boolean {
       return  status >= 400 && status < 500
    }

    constructor(message="While requesting with http, a Client-Side error occurred (4xx)", rawMessage: string, status?: number) {
        super(message);
        this.name = 'RequestError';
        this.rawMessage = rawMessage;
        this.status = status
        Object.setPrototypeOf(this, RequestError.prototype);
    }
}

class ServerError extends HttpError {

    static isServerError(status: number): boolean {
            return status >= 500 && status < 600
    }
    constructor(message="While requesting with http, a Server-Side error occurred (5xx)") {
        super(message);
        this.name = 'ServerError';
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}

export class ForbiddenError extends HttpError {
    static isForbiddenError(status: number): boolean {
        return status === 403
    }

    constructor(message = "While requesting with http, a Forbidden error occurred (403)") {
        super(message);
        this.name = 'ForbiddenError';
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}

class UnauthorizedError extends HttpError {
    static isUnauthorizedError(status: number): boolean {
        return status === 401
    }
    constructor(message = "While requesting with http, a Authorization error occurred (401)") {
        super(message);
        this.name = 'UnauthorizedError';
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}

class UnexpectedHttpError extends HttpError {
    constructor(message?: string) {
        super(message);
        this.name = 'UnexpectedHttpError';
        Object.setPrototypeOf(this, UnexpectedHttpError.prototype);
    }

    static fromError(error: Error): UnexpectedHttpError {
           console.error(error)
        const newMessage = `Unexpected error (originally: ${error.name}): ` + error.message
        return new UnexpectedHttpError(newMessage)
    }
}

export {
    RequestError,
    ServerError,
    UnauthorizedError,
    UnexpectedHttpError,
}
